import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import userStore from './store/userStore';
import { Provider } from 'react-redux';
import {PersistGate } from 'redux-persist/es/integration/react' 
import { persistStore } from 'redux-persist';




const root = ReactDOM.createRoot(document.getElementById('root'));
let persistor = persistStore(userStore)

root.render(
  <React.StrictMode>
    <Provider store={userStore}>
      <PersistGate persistor={persistor}>

    <App />
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
